import { render, staticRenderFns } from "./DropWorkfieldOnUserModal.vue?vue&type=template&id=7f8d90fe"
import script from "./DropWorkfieldOnUserModal.vue?vue&type=script&lang=js"
export * from "./DropWorkfieldOnUserModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports